
import React, { useState } from 'react'
import { IProject, IProjectStage, ISortProject } from './core/_models'
import { AlertCircle, CheckCircle, Circle, Clock, FileCheck, Flag, Rocket, Settings, Shield, Users, Zap, CircleCheck } from "lucide-react";
import ManageEvaluatorModal from '../apps/components/ManageEvaluatorModal'
import SingleProjectStageGateCard from './components/SingleProjectStageGateCard'
import { IProjectEvaluationSummeryData } from '../core/_models';

type Props = {
  project_id: string,
  user_id: string;
  stages: IProjectStage[]
  department_name: string
  project: ISortProject
  summeryData?: IProjectEvaluationSummeryData | null
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const ProjectStage: React.FC<Props> = ({ user_id, project_id, stages, department_name, project, summeryData }) => {
  const [showManageEvaluator, setShowManageEvaluator] = useState<boolean>(false);

  const stageGateInfo = {
    1: {
      stage_id: 'project_stage_0',
      name: 'Project Initiation',
      description: 'Project charter, initial business case, and stakeholder identification',
      icon: Flag,
      color: 'blue'
    },
    2: {
      stage_id: 'project_stage_1',
      name: 'Infrastructure Planning',
      description: 'Detailed requirements gathering, analysis, and documentation',
      icon: FileCheck,
      color: 'purple'
    },
    3: {
      stage_id: 'project_stage_2',
      name: 'Strategic Resourcing',
      description: 'Technical architecture, system design, and solution planning',
      icon: Settings,
      color: 'indigo'
    },
    4: {
      stage_id: 'project_stage_3',
      name: 'Prefeasibility',
      description: 'System development, procurement processes, and vendor selection',
      icon: Zap,
      color: 'yellow'
    },
    5: {
      stage_id: 'project_stage_4',
      name: 'Feasibility',
      description: 'System integration, testing phases, and quality assurance',
      icon: Shield,
      color: 'orange'
    },
    6: {
      stage_id: 'project_stage_5',
      name: 'Design Development',
      description: 'Deployment strategy, rollout planning, and change management',
      icon: Users,
      color: 'teal'
    },
    7: {
      stage_id: 'project_stage_6',
      name: 'Design Documentation',
      description: 'System deployment, user training, and go-live activities',
      icon: Rocket,
      color: 'green'
    },
    8: {
      stage_id: 'project_stage_7',
      name: 'Works',
      description: 'Knowledge transfer, operations documentation, and support setup',
      icon: CheckCircle,
      color: 'emerald'
    },
    9: {
      stage_id: 'project_stage_8',
      name: 'Handover',
      description: 'Final deliverables, lessons learned, and project sign-off',
      icon: Circle,
      color: 'gray'
    },
    10: {
      stage_id: 'project_stage_9',
      name: 'Completion',
      description: 'Final deliverables, lessons learned, and project sign-off',
      icon: CircleCheck,
      color: 'gray'
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'completed':
        return CheckCircle;
      case 'current':
        return Clock;
      case 'blocked':
        return AlertCircle;
      case 'upcoming':
        return Circle;
      default:
        return Circle;
    }
  };

  const handleManageEvaluator = (projectId: string) => {
    setShowManageEvaluator(true);
  };

  return (
    <div className={`my-5`}>
          <SingleProjectStageGateCard
            project={project as unknown as IProject}
            stageGateInfo={stageGateInfo}
            stages={stages}
            getStatusIcon={getStatusIcon}
            onManageEvaluator={handleManageEvaluator}
            setShowManageEvaluator={setShowManageEvaluator}
            summeryData={summeryData}
          />
      {showManageEvaluator && (
        <ManageEvaluatorModal
          project_id={project_id}
          onClose={() => setShowManageEvaluator(false)}
        />
      )}
    </div>
  )
}

export { ProjectStage }
